
export function fmtPing(p: number | null, withSpace: string = ' '): string {
    if (p == null) return "—";
    if (p < 1000) return `${Math.round(p)}${withSpace}ms`;
    return `${(p / 1000).toFixed(1)}${withSpace}s`;
}